class CartFreeSamples extends HTMLElement {
  connectedCallback() {
    if (this.dataset.fsRemoveLines) {
      this.removeUnqualifiedSamples(this.dataset.fsRemoveLines);
      return;
    }

    if (window.cartFreeSamplesModalOpen) {
      this.openModal();
    }
  }

  get modal() {
    return this.querySelector('[data-fs-modal]');
  }

  removeUnqualifiedSamples(keys) {
    const updates = Object.fromEntries(keys.split(',').filter(Boolean).map((key) => [key, 0]));
    if (!Object.keys(updates).length) return;

    fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: 'cart-drawer', sections_url: window.location.pathname }),
    })
      .then((response) => response.json())
      .then((state) => {
        if (!this.closest('cart-drawer')) return window.location.reload();
        const source = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html').querySelector('#cartDrawerInner');
        document.getElementById('cartDrawerInner').innerHTML = source.innerHTML;
        window.inView();
      })
      .catch((error) => console.error(error));
  }

  openModal() {
    if (!this.modal) return;
    this.modal.removeAttribute('hidden');
    window.cartFreeSamplesModalOpen = true;
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.setAttribute('hidden', '');
    window.cartFreeSamplesModalOpen = false;
  }
}

if (!customElements.get('cart-free-samples')) {
  customElements.define('cart-free-samples', CartFreeSamples);
}

if (!window.cartFreeSamplesDelegated) {
  window.cartFreeSamplesDelegated = true;

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-fs-open-modal]')) {
      event.target.closest('cart-free-samples').openModal();
      return;
    }

    if (event.target.closest('[data-fs-close-modal]')) {
      event.target.closest('cart-free-samples').closeModal();
      return;
    }

    if (event.target.closest('[data-fs-keep-shopping]')) {
      document.querySelector('cart-drawer').close();
    }
  });
}
